"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.group")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.group.demonstrations.fin", {
        url: "/demonstracoes/financeiro",
        views: {
            "demonstrationView@nucont.accounting.group.demonstrations": {
                component: "financialDemonstrationsComponent",
                bindings: { companyData: "groupData" }
            }
        },
        params: {
            source: { value: "financeiro", dynamic: true }
        },
        data: {
            layoutConfig: {
                model: "LayoutConfigModel5",
                ignore: { object: "headerConfig", path: "title" },
                setAttrs: [
                    {
                        object: "headerConfig",
                        path: "moduleTitle.text",
                        value: "Demonstrações"
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.description",
                        value: "Entenda o resultado e a posição patrimonial da empresa em cada período."
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.enabled",
                        value: true
                    }
                ]
            }
        }
    });
}
